/* eslint-disable @typescript-eslint/naming-convention */
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AuthService } from 'src/app/core/services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json'
    })
  };
  private readonly  userEndpoint = environment.apiEndpoints.users;
  constructor(private auth: AuthService, private http: HttpClient) { }

  userLogin(loginData: object){
    return this.auth.loginData(loginData);
  }

  requestPasswordReset(email: string){
    return this.auth.forgottenPsw(email);
  }

  verifyRequestLink(token: string){
    return this.auth.verifyLink({token});
  }

  updatePassword(token: string, password: string){
    return this.auth.updatePassword(token, password);
  }

  hasValidAgbVersion(){
    return this.auth.checkAgbVersion();
  }
}
